import type { ReactNode } from 'react';

export const symbol_split_scene_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M600-160q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h180v-520H600q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h180q24 0 42 18t18 42v520q0 24-18 42t-42 18H600ZM458.5-88.63Q450-97.25 450-110v-50H180q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h270v-50q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM780-740v520-520Z"
		/>
	</svg>
);
